
import { Options } from "vue-class-component";

import BasePage from "@/common/BasePage";
import StoreIndex from "./Index.vue";
import { Toast } from "vant";

@Options({
  components: {},
})
/**商家提现记录 */
export default class TxList extends BasePage {
  _title = "畅享服务列表";
  //    reqData={page:0,limit:10,orderId}
  mounted() {
    console.log("服务数据", StoreIndex.serveArr);
    if (!this.serveArr.length) {
      Toast("缺少服务信息， 即将返回个人中心");
      setTimeout(() => {
        this.$router.replace({
          path: "/user",
        });
      }, 1500);
    }
    //    this.reqUrl=this.reqUrl+
  }
  get serveArr() {
    return StoreIndex.serveArr || [];
  }
}
